import { useState, useCallback, useMemo } from 'react'

import { VALIDATION_RULES } from '../constants'

const PREFERENCE_KEY_HIDE_USERNAME = 'reviews.hideUsername'

const readHideUsernamePreference = () => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      const stored = window.localStorage.getItem(PREFERENCE_KEY_HIDE_USERNAME)
      if (stored !== null) return JSON.parse(stored)
    }
  } catch (e) {
    // ignore storage read errors
    return false
  }
  return false
}

const useCommentForm = (activeTab = 'comment') => {
  const [comment, setComment] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState(null)
  const [isNegative, setIsNegative] = useState(false)
  const [hideUsername, setHideUsername] = useState(() => readHideUsernamePreference())

  const handleCommentChange = useCallback((event) => {
    const value = event.target.value
    setComment(value)

    if (error) {
      setError(null)
    }
  }, [error])

  const resetForm = useCallback(() => {
    setComment('')
    if (activeTab === 'review') {
      setIsNegative(false)
    }
  }, [activeTab])

  const getMinLength = useMemo(() => {
    if (activeTab === 'review') {
      return isNegative
        ? VALIDATION_RULES.NEGATIVE_REVIEW_MIN_LENGTH
        : VALIDATION_RULES.POSITIVE_REVIEW_MIN_LENGTH
    }

    return VALIDATION_RULES.COMMENT_MIN_LENGTH
  }, [activeTab, isNegative])

  const canSubmit = comment.trim().length >= getMinLength && !isSubmitting

  const handleHideUsernameChange = useCallback((next) => {
    // Triangle UI Checkbox onChange returns a boolean "checked"
    setHideUsername(!!next)
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem(
          PREFERENCE_KEY_HIDE_USERNAME,
          JSON.stringify(!!next),
        )
      }
    } catch (e) {
      // ignore storage write errors
    }
  }, [])

  return {
    comment,
    error,
    isSubmitting,
    canSubmit,
    handleCommentChange,
    characterCount: comment.length,
    maxLength: VALIDATION_RULES.MAX_LENGTH,
    minLength: getMinLength,
    isNegative,
    setIsNegative,
    hideUsername,
    setHideUsername: handleHideUsernameChange,
    setError,
    setIsSubmitting,
    resetForm,
  }
}

export default useCommentForm
